import { type ConfigParamKey, SETTINGS_CONFIG } from '../../common/constants';

export const getIsProjectOnly = (configParam: string) =>
	// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
	!SETTINGS_CONFIG[configParam as ConfigParamKey].userLocatedBoardAllowed;

export const getIsScrumOnly = (configParam: string) =>
	// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
	!SETTINGS_CONFIG[configParam as ConfigParamKey].kanbanAllowed;

export const getIsJswOnly = (configParam: string) =>
	// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
	!SETTINGS_CONFIG[configParam as ConfigParamKey].jsmAllowed;
